import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function TestimonialSection() {
  return (
    <section
      id="temoignages"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="aurora" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-10 lg:px-12 text-center">
        <div className="font-mono text-xs text-emerald-400 mb-6 tracking-widest">
          // PHILOSOPHIE BAOBSEC
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          data-testid="testimonials-section"
          className="relative"
        >
          <Quote className="w-12 h-12 text-emerald-400/40 mx-auto mb-8" />

          <blockquote className="font-display text-2xl md:text-4xl lg:text-5xl font-medium leading-[1.2] tracking-tight">
            « Chez BaobSec, nous aidons les organisations à{" "}
            <span className="text-emerald-400 italic">structurer</span>, renforcer
            et professionnaliser leur cybersécurité — de la stratégie jusqu'aux
            opérations. Notre force : une{" "}
            <span className="text-emerald-400 italic">double expertise</span>{" "}
            gouvernance et cybersécurité défensive, portée par des experts
            certifiés. »
          </blockquote>

          <div className="mt-10 flex flex-col items-center gap-3">
            <div className="w-16 h-px bg-emerald-500/40" />
            <div className="font-mono text-sm text-gray-400">
              ━ ÉQUIPE BAOBSEC · FRANCE · SÉNÉGAL
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
